<!--    登录页       -->

<template>
    <div id="login-page">
        <section id="content_main">
            <div class="milky"><img src="../../assets/img/login/logo.png">{{platformName}}</div>
            <div id="lgn_Con" class="col-xs-12 col-md-2 col-lg-2 " v-on:mouseenter.stop>
                <table id="login" class="table-lgn col-md-12">
                    <thead>
                        <tr>
                            <td colspan="2">Login</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="msg">
                            <td class="error" colspan="2">
                                <span v-show="lgn_error.info">
                                    <svg class="icon" aria-hidden="true">
                                        <use xlink:href="#icon-error"></use>
                                    </svg>
                                    {{lgn_error.info}}
                                </span>
                            </td>
                        </tr>
                        <tr class="">
                            <td>
                               <span>
                                   <svg class="icon" aria-hidden="true">
                                       <use xlink:href="#icon-yonghu1"></use>
                                   </svg>
                               </span>
                            </td>
                            <td>
                                <input v-model="user_info.lgn_user" type="text" placeholder="用户名" value="" @focus="clear_error">
                            </td>
                        </tr>
                        <tr class="col-12">
                            <td>
                                <span>
                                    <svg class="icon" aria-hidden="true">
                                        <use xlink:href="#icon-mima"></use>
                                    </svg>
                                </span>
                            </td>
                            <td>
                                <input v-model="user_info.lgn_pwd" type="password" placeholder="密码" value="" @focus="clear_error">
                            </td>
                        </tr>
                        <tr class="captcha">
                            <td colspan="2">
                                <span>
                                    <img :src="'data:image/jpg;base64,'+captchaBase64" alt="验证码" title="点击以刷新" @click="get_captcha">
                                </span>
                                <span>
                                    <input v-model="user_info.lgn_captcha" type="text" placeholder="验证码" value="" @focus="clear_error" @keyup.enter="submit">
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <button :class="[login_loading ?'checking': '']" @click="submit">{{login_loading ?'校验中...' : '登录'}}</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <footer>
                <!--<svg class="icon-footer" aria-hidden="true">-->
                    <!--<use xlink:href="#icon-dianhua"></use>-->
                <!--</svg>-->
                <!--<span>热播电话</span>-->
                <!--<span>021-20422220 </span>-->
                <span>Copyright<svg class="icon-footer" aria-hidden="true">
                    <use xlink:href="#icon-banquan"></use>
               </svg>2019 上海日旻能源科技发展有限公司版权所有- <a target="_blank" href="https://beian.miit.gov.cn">沪ICP备2021013856号-7</a></span>
            </footer>
        </section>
    </div>
</template>

<script>
  import axios from 'axios'
  import router from 'vue-router'
  import {mapState, mapMutations} from 'vuex'
  import {EncryptBase64} from "../../assets/js/common/encrypt"
  import {EncryptRsa} from '../../assets/js/common/encrypt';
  import {EncryptData} from "../../assets/js/common/encrypt";
  //背景动态图绘制函数。
  var CanvasParticle = (function () {
    var dist;

    // 根据传入的config初始化画布
    function canvasInit(canvasConfig) {
      canvasConfig = canvasConfig || {};
      // mydiv是你想要将其作为背景的div的ID
      var body = document.getElementById("content_main");
      var canvasObj = document.createElement("canvas");
      var canvas = {
        element: canvasObj,
        points: [],
        // 默认配置
        config: {
          vx: canvasConfig.vx || 4,
          vy: canvasConfig.vy || 4,
          height: canvasConfig.height || 2,
          width: canvasConfig.width || 2,
          count: canvasConfig.count || 100,
          color: canvasConfig.color || "135,206,235",
          stroke: canvasConfig.stroke || "135,206,235",
          dist: canvasConfig.dist || 6000,
          e_dist: canvasConfig.e_dist || 20000,
          max_conn: 10
        }
      };

      // 获取context
      if (canvas.element.getContext("2d")) {
        canvas.context = canvas.element.getContext("2d");
      } else {
        return null;
      }

      body.style.padding = "0";
      body.style.margin = "0";
      // body.replaceChild(canvas.element, canvasDiv);
      body.appendChild(canvas.element);

      canvas.element.style = "position: fixed; top: 0; left: 0; z-index: 0;";
      canvasSize(canvas.element);
      window.onresize = function () {
        canvasSize(canvas.element);
      }
      body.onmousemove = function (e) {
        var event = e || window.event;
        canvas.mouse = {
          x: event.clientX,
          y: event.clientY
        }
      }
      document.onmouseleave = function () {
        canvas.mouse = undefined;
      }
      setInterval(function () {
        drawPoint(canvas);
      }, 40);
    }

    // 设置canvas大小
    function canvasSize(canvas) {

      // 获取特定div的宽高
      var width = document.getElementById("content_main").style.width;
      var height = document.getElementById("content_main").style.height;
      width = parseInt(width);
      height = parseInt(height);
      canvas.width = width || window.innerWeight || document.documentElement.clientWidth || document.body.clientWidth;
      canvas.height = height || window.innerWeight || document.documentElement.clientHeight || document.body.clientHeight;
    }

    // 画点
    function drawPoint(canvas) {
      var context = canvas.context,
        point,
        dist;
      context.clearRect(0, 0, canvas.element.width, canvas.element.height);
      context.beginPath();
      context.fillStyle = "rgb(" + canvas.config.color + ")";
      for (var i = 0, len = canvas.config.count; i < len; i++) {
        if (canvas.points.length != canvas.config.count) {
          // 初始化所有点
          point = {
            x: Math.floor(Math.random() * canvas.element.width),
            y: Math.floor(Math.random() * canvas.element.height),
            vx: canvas.config.vx / 2 - Math.random() * canvas.config.vx,
            vy: canvas.config.vy / 2 - Math.random() * canvas.config.vy
          }
        } else {
          // 处理球的速度和位置，并且做边界处理
          point = borderPoint(canvas.points[i], canvas);
        }
        context.fillRect(point.x - canvas.config.width / 2, point.y - canvas.config.height / 2, canvas.config.width, canvas.config.height);

        canvas.points[i] = point;
      }
      drawLine(context, canvas, canvas.mouse);
      context.closePath();
    }

    // 边界处理
    function borderPoint(point, canvas) {
      var p = point;
      if (point.x <= 0 || point.x >= canvas.element.width) {
        p.vx = -p.vx;
        p.x += p.vx;
      } else if (point.y <= 0 || point.y >= canvas.element.height) {
        p.vy = -p.vy;
        p.y += p.vy;
      } else {
        p = {
          x: p.x + p.vx,
          y: p.y + p.vy,
          vx: p.vx,
          vy: p.vy
        }
      }
      return p;
    }

    // 画线
    function drawLine(context, canvas, mouse) {
      context = context || canvas.context;
      for (var i = 0, len = canvas.config.count; i < len; i++) {
        // 初始化最大连接数
        canvas.points[i].max_conn = 0;
        // point to point
        for (var j = 0; j < len; j++) {
          if (i != j) {
            dist = Math.round(canvas.points[i].x - canvas.points[j].x) * Math.round(canvas.points[i].x - canvas.points[j].x) +
              Math.round(canvas.points[i].y - canvas.points[j].y) * Math.round(canvas.points[i].y - canvas.points[j].y);
            // 两点距离小于吸附距离，而且小于最大连接数，则画线
            if (dist <= canvas.config.dist && canvas.points[i].max_conn < canvas.config.max_conn) {
              canvas.points[i].max_conn++;
              // 距离越远，线条越细，而且越透明
              context.lineWidth = 0.5 - dist / canvas.config.dist;
              context.strokeStyle = "rgba(" + canvas.config.stroke + "," + (1 - dist / canvas.config.dist) + ")"
              context.beginPath();
              context.moveTo(canvas.points[i].x, canvas.points[i].y);
              context.lineTo(canvas.points[j].x, canvas.points[j].y);
              context.stroke();
            }
          }
        }
        // 如果鼠标进入画布
        if (mouse) {
          dist = Math.round(canvas.points[i].x - mouse.x) * Math.round(canvas.points[i].x - mouse.x) +
            Math.round(canvas.points[i].y - mouse.y) * Math.round(canvas.points[i].y - mouse.y);
          // 遇到鼠标吸附距离时加速，直接改变point的x，y值达到加速效果
          if (dist > canvas.config.dist && dist <= canvas.config.e_dist) {
            canvas.points[i].x = canvas.points[i].x + (mouse.x - canvas.points[i].x) / 20;
            canvas.points[i].y = canvas.points[i].y + (mouse.y - canvas.points[i].y) / 20;
          }
          if (dist <= canvas.config.e_dist) {
            context.lineWidth = 1;
            context.strokeStyle = "rgba(" + canvas.config.stroke + "," + (1 - dist / canvas.config.e_dist) + ")";
            context.beginPath();
            context.moveTo(canvas.points[i].x, canvas.points[i].y);
            context.lineTo(mouse.x, mouse.y);
            context.stroke();
          }
        }
      }
    }

    return canvasInit;
  })();

  export default {
    axios,
    name: "loginViews",
    data: function () {
      return {
        //背景图的绘制
        config: {
          vx: 4,	//小球x轴速度,正为右，负为左
          vy: 4,	//小球y轴速度
          height: 2,	//小球高宽，其实为正方形，所以不宜太大
          width: 2,
          count: 200,		//点个数
          color: "180,180,180", 	//点颜色
          stroke: "180,180,180", 		//线条颜色
          dist: 20000, 	//点吸附距离
          e_dist: 20000, 	//鼠标吸附加速距离
          max_conn: 5 	//点到点最大连接数
        },
        platformName: '武汉市民之家云霖数智智能化节能管控系统',
        captchaBase64: '',
        user_info: {
          lgn_user: '',
          lgn_pwd: '',
          lgn_captcha: '',
          lgn_key: '',
        },
        lgn_error: {
          is_send: false,
          info: '',
        },
        login_loading: false,
      }
    },
    created() {
      this.get_captcha();
    },
    mounted() {
      CanvasParticle(this.config);
      // this.check_logined();
    },
    watch: {
      lgn_error: {
        handler(val) {
          if (val.info === '') {
            if (val.is_send) {
              this.login_loading = true;
            } else {
              this.login_loading = false;
            }
          } else {
            if (val.is_send)
              this.login_loading = false;
          }
        },
        deep: true,
      }
    },
    computed: {
      ...mapState([
        'token',
        'active_status',
      ])
    },
    methods: {
      ...mapMutations([
        'getSysId'
      ]),
      submit() {
        // this.$router.push({ path: '/',query: { user: user } });
        const _this = this;
        const user = this.user_info.lgn_user;
        const pwd = EncryptRsa(this.user_info.lgn_pwd);
        const userInfo = {
          username: user,
          password: pwd,
          key: _this.user_info.lgn_key,
          captcha: _this.user_info.lgn_captcha
        };
        if (this.user_info.lgn_user == "" || this.user_info.lgn_user == null || this.user_info.lgn_pwd == "" || this.user_info.lgn_pwd == null) {
          this.lgn_error.is_send = false;
          this.lgn_error.info = "用户名或密码不能为空！";
          return false;
        }
        else if (this.user_info.lgn_captcha == '' || this.user_info.lgn_captcha == null) {
          this.lgn_error.is_send = false;
          this.lgn_error.info = "验证码不能为空！";
          return false;
        }
        else {
          this.login_loading = true;
          axios.post(_this.$api.base.offline + '/token', userInfo)
            .then(res => {
              if (res.data.flag === 0) {
                _this.lgn_error.is_send = true;
                _this.lgn_error.info = res.data.msg.zh;
                _this.get_captcha();//刷新验证码
                _this.user_info.lgn_captcha = '';
              }
              else if (_this.captchaBase64 !== '' && _this.user_info.lgn_key !== '') {
                if (!window.localStorage) {
                  alert('当前浏览器（或版本）不支持localStorage!')
                  return false
                }
                else {
                  let storage = window.localStorage;
                  storage.setItem('username', EncryptBase64(user));
                  storage.setItem('access_token', res.data.data.access_token);
                  storage.setItem("refresh_token", res.data.data.refresh_token);
                  this.$store.commit({
                    type: 'activateToken',
                    status: 1,
                    loginedUser: user,
                  });
                  this.$api.systemInfo.getSysId(EncryptData({}))
                    .then(res1 => {
                      if (res1.data.flag === 1) {
                        res1.data.data.forEach(item => {
                          window.localStorage.setItem(item.name, item.id)
                        });
                        this.$router.push({path: '/index', query: {user: user}});
                      }
                    })
                    .catch(err => {
                      // this.$message.error('E--获取系统id失败！！')
                    })
                }
              }
              else {
                _this.$message.error('未获取到key与验证码！')
              }
            })
            .catch(error => {
              if (error.response) {
                this.$message.error(error.response.data.msg + ' ' + error.response.status)
              }
              else {
                this.$message.error('请求异常!!' + error)
              }
            })
        }
      },
      get_captcha() {
        const _this = this;
        axios.get(`${_this.$api.base.offline}/captcha`, {
          headers: {
            'Content-Type': 'application/json',
          },
          params: EncryptData({})
        })
          .then(res => {
            if (res.data.flag === 1) {
              _this.captchaBase64 = res.data.data.captcha;
              _this.user_info.lgn_key = res.data.data.key;
            } else {
              _this.$message.error(res.data.msg.zh);
            }

          })
          .catch(err => {
            _this.$message.error(err.response.data.msg.zh + '--' + err.response.data.code);
          })
      },
      clear_error() {
        if (this.lgn_error.is_send)
          this.lgn_error.is_send = !this.lgn_error.is_send;
        this.lgn_error.info = '';
      },
    }
  }
</script>

<style>
    @import "../../assets/style/base.css";
    @import "../../assets/style/login.css";
</style>
